export class InvariantError extends Error {
  override readonly name = 'InvariantError';
}

/** Throws when a condition that must hold does not. Narrows `condition` for TypeScript. */
export function invariant(condition: unknown, message: string): asserts condition {
  if (!condition) {
    throw new InvariantError(message);
  }
}

/** Exhaustiveness helper for switch statements over unions. */
export function assertNever(value: never, message = 'Unexpected value'): never {
  throw new InvariantError(`${message}: ${JSON.stringify(value)}`);
}
